import { Handshake } from 'lucide-react';
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import { useVisualViewportHeight } from './hook.js';

export const TermsOfService = () => {

    const vvHeight = useVisualViewportHeight();
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);

    const termsOfServiceList = [
        {
            header: "第1条（利用登録）",
            points: [
                "利用者は、メールアドレスとパスワード、またはGoogleアカウントを利用して登録することができます。",
                "未成年者は、法定代理人の同意を得たうえで本サービスを利用してください。",
                "本サービスの一部の機能では、外部のAIサービスを利用しています。利用者が入力した内容は、応答の生成のために当該サービスに送信される場合があります。",
            ],
        },
        {
            header: "第2条（禁止事項）",
            text: "利用者は、本サービスの利用にあたり、以下の行為を行ってはなりません。",
            points: [
                "法令または公序良俗に反する行為",
                "他の利用者や第三者の権利を侵害する行為",
                "本サービスの運営を妨げる行為",
                "その他、当社が不適切と判断する行為"
            ],
        },
        {
            header: "第3条（料金と支払い）",
            points: [
                "本サービスは定額制の有料サービスです。料金および支払い方法は、当社が別途定めます。",
                "本サービスには、14日間の無料トライアル期間があります。トライアル期間中は、料金は発生しません。",
                "有料プランは、契約更新日に自動的に更新されます。",
                "利用者は、いつでも設定画面から解約することができます。解約後も、お支払い済みの期間が終了するまで本サービスをご利用いただけます。",
                "支払いは、外部決済サービスであるStripeを通じて行われます。利用者はStripeの規約にも従うものとします。",
                "当社はクレジットカード情報を直接保持しません。",
                "原則として支払い済みの料金は返金いたしません。ただし、法令に基づく場合や当社が特別に認める場合を除きます。"
            ],
        },
        {
            header: "第4条（サービスの変更・中断・終了）",
            points: [
                "当社は、事前の通知なく、本サービスの内容を変更し、または提供を中断・終了することがあります。",
                "当社は、本サービスの変更・中断・終了により利用者または第三者に生じたいかなる損害についても責任を負いません。"
            ],
        },
        {
            header: "第5条（アカウントの停止・解除）",
            text: "当社は、利用者が本規約に違反した場合、または当社が必要と判断した場合、事前の通知なく当該利用者のアカウントを停止または解除することができます。",
        },
        {
            header: "第6条（知的財産権）",
            text: "本サービスに関する著作権、商標権その他の知的財産権は、当社または正当な権利者に帰属します。利用者は、当社の許可なく、本サービスを利用して得られたコンテンツを複製、転載、販売、公開その他の方法で利用してはなりません。利用者が本サービス上で入力または投稿した文章等のコンテンツに関する権利は、利用者に帰属します。ただし、当社は、本サービスの提供および改善のために必要な範囲で、これを利用することができるものとします。",
        },
        {
            header: "第7条（免責事項）",
            points: [
                "当社は、本サービスが常に正常に提供されること、エラーや障害が発生しないこと、また特定の学習効果が得られることを保証しません。",
                "当社は、本サービスの利用により生じたいかなる損害についても、法令で認められる範囲を超えて責任を負いません。"
            ]
        },
        {
            header: "第8条（利用規約の変更）",
            text: "当社は、本規約を適宜変更することができます。重要な変更を行う場合、当社は本サービス上での掲示またはメール通知等により利用者に周知します。利用者が変更後に本サービスを利用した場合は、変更に同意したものとみなします。",
        },
        {
            header: "第9条（準拠法・管轄）",
            points: [
                "本規約は日本法に準拠します。",
                "本サービスに関する紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。"
            ]
        }

    ]

    return (
        
        <div 
            className="w-full h-auto lg:h-full flex flex-col gap-8 p-2 lg:p-4 lg:pb-6"
            style={{ maxHeight: isDesktop ? '80vh' : Math.round(vvHeight * 0.8) }}
        >

            <div className="flex gap-2 items-center">
                <span className="">
                    <Handshake className='text-base-text size-6' strokeWidth={1} />
                </span>
                <h1 className="text-base-text font-light text-lg w-max">
                    利用規約
                </h1>
            </div>


            <div className="flex flex-col pt-4 gap-6 h-full overflow-y-auto pr-2">
                <p className="text-base-text font-light">
                    本利用規約（以下「本規約」といいます。）は、ユーザー（以下「利用者」といいます。）が、aome合同会社（以下「当社」といいます。）の提供する英語学習プラットフォーム（以下「本サービス」といいます。）を利用する際の条件を定めるものです。利用者は、本規約に同意のうえで本サービスを利用するものとします。
                </p>
                {termsOfServiceList.map((termsOfService, index) => {
                    return (
                        <div className="flex flex-col gap-2" key={index}>
                            <p className="text-base-text font-normal">{termsOfService.header}</p>
                            {termsOfService.text && <p className="text-base-text font-light">{termsOfService.text}</p>}
                            {termsOfService.points &&
                                <ul className="list-disc pl-8">
                                    {termsOfService.points.map((point, index) => {
                                        return (
                                            <li className="text-base-text font-light" key={index}>{point}</li>
                                        )
                                    })}
                                </ul>
                            }

                        </div>
                    )
                })}
            </div>
        </div>
    )
}